import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UiCustomSliderComponent } from './ui-custom-slider.component';
@NgModule({
	declarations: [
		UiCustomSliderComponent
	],
	imports: [
		CommonModule,
		FormsModule,

	],
	exports: [
		UiCustomSliderComponent
	]
})
export class UiCustomSliderModule { }
